import { authRoles } from 'app/auth';
import FeltoltesTesztlapTable from 'app/admin/feltoltestesztlap/table/FeltoltesTesztlapTable';
import FeltoltesTesztlapEditForm from 'app/admin/feltoltestesztlap/editform/FeltoltesTesztlapSubmitForm';

export default [
	{
		path: '/feltoltestesztlap/edit/:id',
		component: FeltoltesTesztlapEditForm,
		auth: authRoles.vizsgaztato
	},
	{
		path: '/feltoltestesztlap/:sessionNameParam?',
		component: FeltoltesTesztlapTable,
		auth: authRoles.vizsgaztato
	}
];
